import React from "react";
export const languageLabel = (
    linkLabel,
    linkNativeName,
    linkTranslatedName,
    languageCode,
    activeCode,
) => {
    if (!linkNativeName || !linkTranslatedName || !languageCode) {
        return linkLabel;
    }
    if (languageCode === "zh-cn") {
        languageCode = "zh-hans";
    }
    if (activeCode === "zh-cn") {
        activeCode = "zh-hans";
    }
    const isCurrentLanguage = activeCode === languageCode;
    if (linkNativeName === linkTranslatedName) {
        if (isCurrentLanguage) {
            return linkNativeName;
        }
        return <span lang={languageCode}>{linkNativeName}</span>;
    }
    const translatedName =
        activeCode === "en" ? (
            linkTranslatedName
        ) : (
            <span lang="en">{linkTranslatedName}</span>
        );
    if (isCurrentLanguage) {
        return (
            <span>
                {linkNativeName} - {translatedName}
            </span>
        );
    }
    return (
        <span>
            <span lang={languageCode}>{linkNativeName}</span> - {translatedName}
        </span>
    );
};
